import EquipmentTypeClassXref from './EquipmentTypeClassXref'
import Customer from './Customer'
import EquipmentGraphics from './EquipmentGraphics'
import Request from './Request'
export class Equipment {
    ID: number;
    SerialNumber: string;
    ManufacturerSerialNumber: string;
    ModelGroup: string;
    EquipmentNumber: string;
    ManufacturerName: string;
    SalesOfficeCode: string;
    StorageLocation: string;
    CustomerName: string;
    CustomerNumber: string;
    EquipmentType: string;
    EquipmentTypeClassXref?: EquipmentTypeClassXref;
    ProcessedByRequest?: Request;
    Customer?: Customer;
    EquipmentGraphicsID?: number;
    EquipmentGraphics?: EquipmentGraphics;
    MaterialNumber: string;
}

export default Equipment;